// extracted by mini-css-extract-plugin
export default {"BlogDetailsContainer":"BlogDetails_BlogDetailsContainer__kjQt2","blogTitle":"BlogDetails_blogTitle__gcBee","blogDescription":"BlogDetails_blogDescription__2uabx"};